import { ContactInfoState, contactInfoMachine } from 'domains/signup/contactInfo/contactInfoMachine';
import { isArray } from 'lodash';
import { createActorContextFromActor } from 'utils/xstate/context';

export const ContactInfoContext = createActorContextFromActor<typeof contactInfoMachine>();

export const withContactInfoMachineState = (
  Component: React.FC,
  matchingState: ContactInfoState | ContactInfoState[],
) => {
  return (props: Record<string, unknown>) => {
    const matchesState = ContactInfoContext.useSelector(state => {
      if (isArray(matchingState) && matchingState.some(s => state.matches(s))) {
        return true;
      }

      if (state.matches(matchingState as ContactInfoState)) {
        return true;
      }

      return false;
    });

    if (matchesState) {
      return <Component {...props} />;
    }
    return null;
  };
};
